import { render, staticRenderFns } from "./New_PaiementV2.vue?vue&type=template&id=bee6da6a&"
import script from "./New_PaiementV2.vue?vue&type=script&lang=js&"
export * from "./New_PaiementV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports